import image_1 from '../../assets/programs/ug_anveshan/image_1.webp'
import image_2 from '../../assets/programs/ug_anveshan/image_2.webp'
import image_3 from '../../assets/programs/sci_tech_spins/image1.webp'
import image_4 from '../../assets/programs/sci_tech_spins/image2.webp'
import image_5 from '../../assets/programs/sci_tech_spins/image3.webp'

const ug_anveshan_data = {
    "title": "ANVESHAN: INNOVATION AND EXPLORATION ACROSS DISCIPLINES",
    "description": " We bring IITD professors to the forefront, showcasing cutting-edge research through engaging lectures and captivating lab demonstrations for school and college students. These sessions offer students a thrilling journey into the mysteries of science and technology, sparking curiosity and innovation.",
    "content": [
        {
            "primaryHeading": "",
            "subContent": [
                {
                    "secondaryHeading": "",
                    "description": "",
                    "images": [
                        {
                            "src": image_1,
                            "desc": ""
                        },
                        {
                            "src": image_3,
                            "desc": ""
                        },
                        {
                            "src": image_4,
                            "desc": ""
                        }
                    ]
                }
            ]
        }
    ]
}

export default ug_anveshan_data;